// Async Downloads functionality
function initializeAsyncDownloads() {
  // Handle async download button clicks
  document.addEventListener('click', function(e) {
    if (e.target.closest('.async-download-btn')) {
      e.preventDefault();
      e.stopPropagation();
      
      const button = e.target.closest('.async-download-btn');
      const observationId = button.getAttribute('data-observation-id');
      const observationType = button.getAttribute('data-observation-type');
      const videoType = button.getAttribute('data-video-type');
      
      // Disable button to prevent multiple clicks
      button.disabled = true;
      button.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
      
      // Send async download request
      requestAsyncDownload(observationId, observationType, videoType, button);
    }
    
    // Handle bulk async download button clicks (for clips page)
    if (e.target.closest('.async-bulk-download-btn')) {
      e.preventDefault();
      e.stopPropagation();
      
      const button = e.target.closest('.async-bulk-download-btn');
      
      // Get all selected checkboxes
      const selectedCheckboxes = document.querySelectorAll('.clip-checkbox.click-checkbox-vide-clip-icon:checked');
      
      if (selectedCheckboxes.length === 0) {
        showCustomToast('Please select at least one clip to download.', 'error');
        return;
      }
      
      // Disable button to prevent multiple clicks
      button.disabled = true;
      button.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
      
      // Process all selected items
      processBulkDownloads(selectedCheckboxes, button);
    }
    
    // Handle bulk download all clips button clicks (for downloads page)
    if (e.target.closest('.async-bulk-download-all-clips-btn')) {
      e.preventDefault();
      e.stopPropagation();
      
      const button = e.target.closest('.async-bulk-download-all-clips-btn');
      
      // Get all selected checkboxes
      const selectedCheckboxes = document.querySelectorAll('.clip-checkbox.click-checkbox-vide-clip-icon:checked');
      
      if (selectedCheckboxes.length === 0) {
        showCustomToast('Please select at least one clip to download.', 'error');
        return;
      }
      
      // Disable button to prevent multiple clicks
      button.disabled = true;
      button.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
      
      // Process all selected items for direct download
      processBulkDirectDownloads(selectedCheckboxes, button);
    }
  });
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', initializeAsyncDownloads);

initializeAsyncDownloads();
// Initialize on Turbolinks load
document.addEventListener('turbolinks:load', initializeAsyncDownloads);

function requestAsyncDownload(observationId, observationType, videoType, button) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  
  fetch('/video_centre/async_downloads', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken
    },
    body: JSON.stringify({
      observation_id: observationId,
      observation_type: observationType,
      video_type: videoType
    })
  })
  .then(response => response.json())
  .then(data => {
    if (data.status === 'processing') {
      // Show custom toast
      showCustomToast(data.message, 'info');
    } else {
      // Show error toast
      showCustomToast(data.error || 'An error occurred while processing your download request.', 'error');
    }
  })
  .catch(error => {
    console.error('Error:', error);
    showCustomToast('An error occurred while processing your download request.', 'error');
  })
  .finally(() => {
    // Re-enable button
    button.disabled = false;
    button.innerHTML = '<i class="fas fa-cloud-download-alt"></i>';
  });
}

function processBulkDownloads(selectedCheckboxes, button) {
  const totalItems = selectedCheckboxes.length;
  let processedItems = 0;
  let successCount = 0;
  let errorCount = 0;
  
  // Show initial toast
  showCustomToast(`Starting bulk download for ${totalItems} selected clips...`, 'info');
  
  // Process each selected item
  selectedCheckboxes.forEach((checkbox, index) => {
    // Find the corresponding download button for this row
    const row = checkbox.closest('tr');
    const downloadButton = row.querySelector('.async-download-btn');
    
    if (downloadButton) {
      const observationId = downloadButton.getAttribute('data-observation-id');
      const observationType = downloadButton.getAttribute('data-observation-type');
      const videoType = downloadButton.getAttribute('data-video-type');
      
      // Add delay between requests to avoid overwhelming the server
      setTimeout(() => {
        requestBulkDownload(observationId, observationType, videoType, () => {
          processedItems++;
          successCount++;
          
          // Update progress
          if (processedItems === totalItems) {
            // All items processed
            showCustomToast(`Bulk download completed! ${successCount} clips queued for processing.`, 'success');
            button.disabled = false;
            button.innerHTML = '<i class="fas fa-cloud-download-alt"></i>';
          }
        }, () => {
          processedItems++;
          errorCount++;
          
          // Update progress
          if (processedItems === totalItems) {
            // All items processed
            const message = errorCount === totalItems 
              ? 'All downloads failed. Please try again.' 
              : `Bulk download completed with ${successCount} successful and ${errorCount} failed.`;
            showCustomToast(message, errorCount === totalItems ? 'error' : 'info');
            button.disabled = false;
            button.innerHTML = '<i class="fas fa-cloud-download-alt"></i>';
          }
        });
      }, index * 500); // 500ms delay between requests
    } else {
      processedItems++;
      errorCount++;
      
      if (processedItems === totalItems) {
        const message = errorCount === totalItems 
          ? 'All downloads failed. Please try again.' 
          : `Bulk download completed with ${successCount} successful and ${errorCount} failed.`;
        showCustomToast(message, errorCount === totalItems ? 'error' : 'info');
        button.disabled = false;
        button.innerHTML = '<i class="fas fa-cloud-download-alt"></i>';
      }
    }
  });
}

function processBulkDirectDownloads(selectedCheckboxes, button) {
  const totalItems = selectedCheckboxes.length;
  let processedItems = 0;
  let successCount = 0;
  let errorCount = 0;
  
  // Create progress modal
  const progressModal = createProgressModal(totalItems);
  document.body.appendChild(progressModal);
  
  // Show progress modal
  progressModal.style.display = 'flex';
  
  // Create a hidden iframe for downloads
  let downloadIframe = document.getElementById('bulk-download-iframe');
  if (!downloadIframe) {
    downloadIframe = document.createElement('iframe');
    downloadIframe.id = 'bulk-download-iframe';
    downloadIframe.style.display = 'none';
    document.body.appendChild(downloadIframe);
  }
  
  // Process each selected item
  selectedCheckboxes.forEach((checkbox, index) => {
    // Find the corresponding download link for this row
    const row = checkbox.closest('tr');
    const downloadLink = row.querySelector('a[href*="/download"]');
    
    if (downloadLink) {
      // Add delay between requests to avoid overwhelming the server
      setTimeout(() => {
        // Update progress
        processedItems++;
        successCount++;
        updateProgress(progressModal, processedItems, totalItems, successCount, errorCount);
        
        // Use iframe to trigger download without redirecting the page
        downloadIframe.src = downloadLink.href;
        
        // Update progress
        if (processedItems === totalItems) {
          // All items processed
          setTimeout(() => {
            hideProgressModal(progressModal);
            showCustomToast(`Bulk download completed! ${successCount} clips downloaded.`, 'success');
            button.disabled = false;
            button.innerHTML = '<i class="fas fa-cloud-download-alt"></i>';
            
            // Clean up iframe after a delay
            setTimeout(() => {
              if (downloadIframe && downloadIframe.parentNode) {
                downloadIframe.parentNode.removeChild(downloadIframe);
              }
            }, 5000);
          }, 1000);
        }
      }, index * 1000); // 1 second delay between downloads to avoid browser blocking
    } else {
      processedItems++;
      errorCount++;
      updateProgress(progressModal, processedItems, totalItems, successCount, errorCount);
      
      if (processedItems === totalItems) {
        setTimeout(() => {
          hideProgressModal(progressModal);
          const message = errorCount === totalItems 
            ? 'All downloads failed. Please try again.' 
            : `Bulk download completed with ${successCount} successful and ${errorCount} failed.`;
          showCustomToast(message, errorCount === totalItems ? 'error' : 'info');
          button.disabled = false;
          button.innerHTML = '<i class="fas fa-cloud-download-alt"></i>';
          
          // Clean up iframe after a delay
          setTimeout(() => {
            if (downloadIframe && downloadIframe.parentNode) {
              downloadIframe.parentNode.removeChild(downloadIframe);
            }
          }, 5000);
        }, 1000);
      }
    }
  });
}

function createProgressModal(totalItems) {
  const modal = document.createElement('div');
  modal.id = 'bulk-download-progress-modal';
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  `;
  
  modal.innerHTML = `
    <div style="
      background: rgba(34, 40, 49, 0.98);
      border-radius: 10px;
      padding: 32px 28px 28px 28px;
      max-width: 400px;
      width: 90%;
      text-align: center;
      box-shadow: 0 4px 24px rgba(0,0,0,0.5);
      color: #f5f6fa;
    ">
      <div style="margin-bottom: 20px;">
        <i class="fas fa-cloud-download-alt" style="font-size: 48px; color: #4fc3f7; margin-bottom: 15px;"></i>
        <h3 style="margin: 0 0 10px 0; color: #f5f6fa; font-weight: 600; letter-spacing: 1px;">Downloading Clips</h3>
        <p style="margin: 0; color: #b0bec5; font-size: 15px;">Please wait while your clips are being downloaded...</p>
      </div>
      
      <div style="margin-bottom: 20px;">
        <div style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
        ">
          <span style="font-weight: bold; color: #b0bec5;">Progress</span>
          <span id="progress-counter" style="font-weight: bold; color: #4fc3f7;">0/${totalItems}</span>
        </div>
        
        <div style="
          width: 100%;
          height: 10px;
          background: #232a36;
          border-radius: 5px;
          overflow: hidden;
        ">
          <div id="progress-bar" style="
            width: 0%;
            height: 100%;
            background: linear-gradient(90deg, #4fc3f7, #1976d2);
            border-radius: 5px;
            transition: width 0.3s ease;
          "></div>
        </div>
      </div>
      
      <div style="
        display: flex;
        justify-content: space-between;
        font-size: 13px;
        color: #b0bec5;
      ">
        <span>Successful: <span id="success-count" style="color: #81c784; font-weight: bold;">0</span></span>
        <span>Failed: <span id="error-count" style="color: #e57373; font-weight: bold;">0</span></span>
      </div>
      
      <div style="margin-top: 24px;">
        <button id="cancel-download-btn" style="
          background: #232a36;
          color: #f5f6fa;
          border: none;
          padding: 10px 22px;
          border-radius: 5px;
          cursor: pointer;
          font-size: 15px;
          font-weight: 500;
          letter-spacing: 1px;
          transition: background 0.2s;
        " onmouseover="this.style.background='#394353'" onmouseout="this.style.background='#232a36'">Cancel</button>
      </div>
    </div>
  `;
  
  // Add cancel functionality
  const cancelBtn = modal.querySelector('#cancel-download-btn');
  cancelBtn.addEventListener('click', () => {
    hideProgressModal(modal);
    // Re-enable the main button
    const mainButton = document.querySelector('.async-bulk-download-all-clips-btn');
    if (mainButton) {
      mainButton.disabled = false;
      mainButton.innerHTML = '<i class="fas fa-cloud-download-alt"></i>';
    }
  });
  
  return modal;
}

function updateProgress(modal, processedItems, totalItems, successCount, errorCount) {
  const progressBar = modal.querySelector('#progress-bar');
  const progressCounter = modal.querySelector('#progress-counter');
  const successCountEl = modal.querySelector('#success-count');
  const errorCountEl = modal.querySelector('#error-count');
  
  const percentage = (processedItems / totalItems) * 100;
  
  progressBar.style.width = `${percentage}%`;
  progressCounter.textContent = `${processedItems}/${totalItems}`;
  successCountEl.textContent = successCount;
  errorCountEl.textContent = errorCount;
}

function hideProgressModal(modal) {
  modal.style.display = 'none';
  if (modal.parentNode) {
    modal.parentNode.removeChild(modal);
  }
}

function requestBulkDownload(observationId, observationType, videoType, onSuccess, onError) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  
  fetch('/video_centre/async_downloads', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken
    },
    body: JSON.stringify({
      observation_id: observationId,
      observation_type: observationType,
      video_type: videoType
    })
  })
  .then(response => response.json())
  .then(data => {
    if (data.status === 'processing') {
      onSuccess();
    } else {
      onError();
    }
  })
  .catch(error => {
    console.error('Error:', error);
    onError();
  });
}

function showCustomToast(message, type = 'info') {
  // Get or create toast container
  let toastContainer = document.getElementById('custom-toast-container');
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'custom-toast-container';
    toastContainer.style.cssText = `
      position: fixed;
      top: 20px;
      right: 50%;
      margin-right: -175px;
      z-index: 99999;
      max-width: 350px;
    `;
    document.body.appendChild(toastContainer);
  }
  
  // Create toast element
  const toastElement = document.createElement('div');
  toastElement.style.cssText = `
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    margin-bottom: 10px;
    padding: 15px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    font-size: 14px;
    line-height: 1.4;
    color: #fff;
    opacity: 0;
    transform: translateX(100%);
    transition: all 0.3s ease;
    max-width: 100%;
    word-wrap: break-word;
  `;
  
  // Set background color based on type
  if (type === 'error') {
    toastElement.style.borderLeft = '4px solid #dc3545';
    toastElement.style.backgroundColor = '#dc3545';
  } else if (type === 'success') {
    toastElement.style.borderLeft = '4px solid #28a745';
    toastElement.style.backgroundColor = '#28a745';
  } else {
    toastElement.style.borderLeft = '4px solid #2f96b4';
    toastElement.style.backgroundColor = '#2f96b4';
  }
  
  // Create toast content
  toastElement.innerHTML = `
    <div style="display: flex; justify-content: space-between; align-items: flex-start;">
      <div style="flex: 1; margin-right: 10px;">
        <div>${message}</div>
      </div>
      <button type="button" style="
        background: none;
        border: none;
        font-size: 18px;
        cursor: pointer;
        color: #666;
        padding: 0;
        margin: 0;
        line-height: 1;
      " onclick="this.parentElement.parentElement.remove()">&times;</button>
    </div>
  `;
  
  // Add toast to container
  toastContainer.appendChild(toastElement);
  
  // Animate in
  setTimeout(() => {
    toastElement.style.opacity = '1';
    toastElement.style.transform = 'translateX(0)';
  }, 10);
  
  // Auto remove after 5 seconds
  setTimeout(() => {
    if (toastElement.parentElement) {
      toastElement.style.opacity = '0';
      toastElement.style.transform = 'translateX(100%)';
      setTimeout(() => {
        if (toastElement.parentElement) {
          toastElement.parentElement.removeChild(toastElement);
        }
      }, 300);
    }
  }, 5000);
}

 